import React, { useState } from 'react';
import { RBHBox, RBHButton } from '..';
import { FormattedMessage } from 'react-intl';
import styleButton from '../rbh-button/styles';
import { useDispatch, useSelector } from 'react-redux';
import { GENERAL_STATE_KEY, generalStateSelector, TNC_MODAL } from '../../../redux/general/general-reducer';
import styles from './styles';
import { GENERAL_REQUEST_ID_LIST } from '../../../redux/general/general-constant';
import { GeneralService } from '../../../redux/general/general-service';
import { generalSagas } from '../../../redux/general/general-saga';
import { generalCreators } from '../../../redux/general/general-action';
import { httpCreators } from '@ppvrbh/merchant-frontend-core';
import { Modal } from 'antd';
import { history } from '../../../router';

export const RBHTncModal = () => {
  const dispatch = useDispatch();
  const modal = useSelector(generalStateSelector(GENERAL_STATE_KEY.TNC_MODAL)) as TNC_MODAL;
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  const pushToMain = () => {
    const hideModal = {
      visible: false
    };
    dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.TNC_MODAL, hideModal));
    window.scrollTo({ top: 0, behavior: 'smooth' });
    history.push('/main');
    setIsButtonDisabled(true);
  };

  const onClickTnc = () => {
    dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.TNC_MODAL, {
      visible: false
    }));
    const data = {
      tncId: modal.tncId
    };
    dispatch(httpCreators.request({
      id: GENERAL_REQUEST_ID_LIST.POST_TNC,
      sagaHandler: generalSagas.postTncHandler as any,
      callbackParams: { pushToMain },
      service: GeneralService.postTnc,
      serviceParams: data
    }));
  };

  const onScrollOverBox = (e: any) => {
    const { scrollHeight, scrollTop } = e.target;
    if (scrollHeight - scrollTop >= 450) {
      // check if user scroll to bottom yet
    } else {
      setIsButtonDisabled(false);
    }
  };

  const onMouseEnterBox = () => {
    const elmnt = document.getElementById('tncAcceptance-box');
    const y = elmnt?.scrollHeight;
    if (y) {
      if (y === 418) {
        setIsButtonDisabled(false);
      }
    }
  };

  const showTncModal = () => {
    return (
      <RBHBox style={styles.default}>
        <RBHBox data-testid={'tncAcceptance-box'} id={'tncAcceptance-box'} style={styles.contentTnc} onMouseEnter={onMouseEnterBox}
          dangerouslySetInnerHTML={{ __html: modal.contentHtml }} onScroll={onScrollOverBox} >
        </RBHBox>
        <RBHBox style={styles.buttonBoxTnc}>
          <RBHButton style={styleButton.buttonFromCancelGradient}
            id={'accept-tnc-cancel'}
            data-testid={'accept-tnc-cancel'}
            htmlType={'button'}
            disabled={isButtonDisabled}
            type={'primary'}
            onClick={pushToMain}>
            <FormattedMessage id={'main.modal.tnc.button.cancel'} />
          </RBHButton>
          <RBHButton style={styleButton.buttonModalConfirmGradient}
            id={'accept-tnc-confirm'}
            data-testid={'accept-tnc-confirm'}
            htmlType={'submit'}
            disabled={isButtonDisabled}
            type={'primary'}
            onClick={onClickTnc}>
            <FormattedMessage id={'main.modal.tnc.button.confirm'} />
          </RBHButton>
        </RBHBox>
      </RBHBox>
    );
  };

  return (
    <Modal
      destroyOnClose={true}
      closable={false}
      visible={modal.visible}
      centered={true}
      footer={null}>
      {showTncModal()}
    </Modal>
  );
};

export default RBHTncModal;
